'use strict';

require('../../style/index.less');

require('./index.less');

require('../../tooltip/style');


/*****************
 ** WEBPACK FOOTER
 ** ./~/antd/lib/menu/style/index.js
 ** module id = 492
 ** module chunks = 1
 **/